<template>
  <span class="scaling-svg-container">
    <svg
      class="scaling-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="14.376"
      height="14.376"
      viewBox="0 0 14.376 14.376"
    >
      <path
        d="M5.391,14.376h0l-4.47,0a.9.9,0,0,1-.9-.895L0,8.989a.9.9,0,0,1,.894-.9.9.9,0,0,1,.9.895L1.809,11.3,4.756,8.349A.9.9,0,0,1,6.026,9.62L3.068,12.578H5.391a.9.9,0,0,1,0,1.8Zm8.087-8.087a.9.9,0,0,1-.9-.9l0-2.323L9.62,6.026A.9.9,0,0,1,8.349,4.756L11.3,1.809,8.981,1.8a.9.9,0,0,1,0-1.8l4.495.023a.9.9,0,0,1,.894.9l0,4.47a.9.9,0,0,1-.9.9Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class UnpairIcon extends Vue {}
</script>

<style>
</style>
